import React from 'react';

import styled from 'styled-components';

import { isMysteryShopAdmin, isMysteryShopShopper } from 'helpers/permissions';
import { useAppSelector } from 'store/hook';

import ShopRequestsCompanyFilter from './ShopRequestsCompanyFilter';
import ShopRequestsDueDateEndFilter from './ShopRequestsDueDateEndFilter';
import ShopRequestsDueDateStartFilter from './ShopRequestsDueDateStartFilter';
import ShopRequestGroupByFilter from './ShopRequestsGroupByFilter';
import ShopRequestsStatusFilter from './ShopRequestsStatusFilter';
import ShopRequestsTypeFilter from './ShopRequestsTypeFilter';
import ShopRequestsUserFilter from './ShopRequestsUserFilter';
import { SHOP_REQUEST_COLUMNS, SHOP_REQUEST_DUE_DATE_RANGES, SHOP_REQUESTS_PAGE_SIZE } from '../constants';
import { useShopRequestsDataContext } from '../ShopRequestsDataContext';

const Container = styled.div`
  margin: 20px 0 20px 30px;
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const Link = styled.span`
  cursor: pointer;
  font-size: 10px;
  color: var(--text-secondary);
  &.active {
    color: var(--active-blue);
  }
  &.disabled {
    pointer-events: none;
  }
`;

const ResetContainer = styled.div`
  display: flex;
  align-items: center;
  border-left: 1px solid var(--line-gray);
  margin-left: 10px;
  padding-left: 10px;
  height: 12px;
`;

const ShopRequestFilters = () => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const { filters, ordering, setFilters, setOrdering } = useShopRequestsDataContext();

  const isShopper =
    currentUser && isMysteryShopShopper(currentUser) && !currentUser.isSuperuser && !isMysteryShopAdmin(currentUser);

  const resetFilters = () => {
    setFilters({
      page: 1,
      pageSize: SHOP_REQUESTS_PAGE_SIZE,
      search: '',
      status: [],
      requestType: [],
      shoppers: [],
      auditors: [],
      companyIds: [],
      noPropagation: false,
      dueDateStart: undefined,
      dueDateEnd: undefined,
      dueDateRange: SHOP_REQUEST_DUE_DATE_RANGES.DUE_THIS_WEEK,
      groupBy: undefined,
    });
    if (ordering !== SHOP_REQUEST_COLUMNS.dueDate.id) {
      setOrdering(SHOP_REQUEST_COLUMNS.dueDate.id);
    }
  };

  return (
    <Container>
      <ShopRequestGroupByFilter />
      <ShopRequestsStatusFilter />
      <ShopRequestsTypeFilter />
      {!isShopper && <ShopRequestsUserFilter fieldKey="shoppers" Label="Assignee" />}
      {!isShopper && <ShopRequestsUserFilter fieldKey="auditors" Label="Auditor" />}
      <ShopRequestsDueDateStartFilter />
      <ShopRequestsDueDateEndFilter />
      <ShopRequestsCompanyFilter />
      <ResetContainer>
        <Link onClick={resetFilters}>Reset</Link>
      </ResetContainer>
    </Container>
  );
};

export default ShopRequestFilters;
